import { Drawer } from '@mui/material';
import { useAtomValue } from 'jotai';

import { useTransition } from '../../../utils/cssTransitions';
import { ReturnComponent } from '../../../utils/reactTypes';
import {
    closedNavDrawerWidthDesktop,
    isGlobalDrawerOpenAtom,
    openNavDrawerWidth,
} from '../lib/constants';
import { GlobalDrawerItems } from './GlobalDrawerItems';

export const GlobalDesktopNavigationDrawer = (): ReturnComponent => {
    const isDrawerOpen = useAtomValue(isGlobalDrawerOpenAtom);
    const transition = useTransition(['width']);

    return (
        <Drawer
            variant={'permanent'}
            sx={{
                width: isDrawerOpen ? openNavDrawerWidth : closedNavDrawerWidthDesktop,
                flexShrink: 0,
                whiteSpace: 'nowrap',
                '& .MuiDrawer-paper': {
                    width: isDrawerOpen ? openNavDrawerWidth : closedNavDrawerWidthDesktop,
                    overflowX: 'hidden',
                    transition,
                    boxSizing: 'border-box',
                    backgroundColor: '#F5F5F5', // Light grey background
                },
            }}
        >
            <GlobalDrawerItems />
        </Drawer>
    );
};
